import { site } from '../../../mocks/entertainment';
import SectionHead from './SectionHead';

const stats = [
  { icon: 'ri-archive-fill', num: '50+', label: '期精华盘点' },
  { icon: 'ri-sparkling-fill', num: '1000+', label: '名场面收录' },
  { icon: 'ri-calendar-event-fill', num: '360', label: '年度事件归档' },
  { icon: 'ri-team-fill', num: '周更', label: '持续追更' },
];

const principles = [
  { icon: 'ri-eye-line', title: '只看热闹，不站队', text: '做第三方视角的讨论化盘点，对争议保持距离。' },
  { icon: 'ri-focus-3-line', title: '来源优先，疑点标注', text: '公开信息交叉比对，未证实的说法明确标「网传」。' },
  { icon: 'ri-heart-3-line', title: '不恶意揣测，不定罪', text: '尊重每一位从业者，对个人品质不作不负责任的定论。' },
  { icon: 'ri-leaf-line', title: '克制而克制地吃瓜', text: '少一点情绪化煽动，多一点精炼与信息量。' },
];

const praise = [
  { text: '一周没刷微博，回来看这一篇就补完了，省心。', who: '追剧爱好者 · 阿岚' },
  { text: '年度盘点和名场面混剪绝了，考古停不下来。', who: '综艺重度患者 · 老周' },
  { text: '能把热点盘得这么中立客观的不多，会一直关注。', who: '行业观察 · MoMo' },
];

export default function About() {
  return (
    <section id="about" className="relative scroll-mt-16 bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          {/* 文字 */}
          <div>
            <SectionHead eyebrow="关于本站" title={`${site.brand}，把瓜吃明白`} />
            <p className="mt-5 text-sm leading-relaxed text-foreground-700 md:text-base">
              {site.brand}
              是一个专注娱乐圈精华盘点的观察站。我们不追进度、不播直播，而是把每周的热门事件、年度大瓜与明星名场面，
              整理成一份精炼好读的「备忘录」——正如站点slogan所说：大瓜合集，一网打尽，收藏这一篇就够了。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              我们相信，娱乐盘点最大的价值不是制造对立，而是帮大家省时间、看门道。站内所有内容以公开信息与讨论为依据，
              坚持观点化而非情绪化，力求把「吃瓜」这件事做得轻松、克制又有信息量。
            </p>

            <div className="mt-7 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {principles.map((p) => (
                <div key={p.title} className="flex gap-3 rounded-xl bg-background-100 p-4 ring-1 ring-background-200/70">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-lg text-primary-700">
                    <i className={p.icon} aria-hidden="true"></i>
                  </span>
                  <div>
                    <h3 className="text-sm font-bold text-foreground-950">{p.title}</h3>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.text}</p>
                  </div>
                </div>
              ))}
            </div>

            <dl className="mt-7 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {stats.map((s) => (
                <div key={s.label} className="rounded-xl bg-background-50 p-4 text-center ring-1 ring-background-200/80">
                  <span className="mx-auto flex h-8 w-8 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                    <i className={s.icon} aria-hidden="true"></i>
                  </span>
                  <dd className="big-rank mt-2 text-xl text-foreground-950">{s.num}</dd>
                  <dt className="mt-0.5 text-xs text-foreground-500">{s.label}</dt>
                </div>
              ))}
            </dl>
          </div>

          {/* 图片 */}
          <div className="flex flex-col justify-center gap-5">
            <div className="relative overflow-hidden rounded-2xl ring-1 ring-background-200">
              <div className="aspect-[5/4] w-full">
                <img
                  src="https://readdy.ai/api/search-image?query=cozy%20modern%20newsroom%20editorial%20office%20scene%20with%20warm%20desk%20lamp%20glow%20stacked%20magazines%20and%20a%20notebook%20with%20handwritten%20notes%20on%20a%20warm%20cream%20wooden%20desk%20cinematic%20warm%20amber%20editorial%20photography%20thoughtful%20workspace%20atmosphere%20no%20people%20no%20text&width=1100&height=880&seq=about-edit-1&orientation=landscape"
                  alt="瓜友观察站编辑部的工作台与盘点资料，暖调纪实风格"
                  title="瓜友观察站编辑部"
                  className="h-full w-full object-cover object-center"
                />
              </div>
              <div className="absolute inset-x-4 bottom-4 flex items-center gap-3 rounded-xl bg-background-950/55 p-3.5 text-background-50 backdrop-blur">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-950">
                  <i className="ri-flashlight-fill" aria-hidden="true"></i>
                </span>
                <div>
                  <p className="text-sm font-bold">{site.slogan}</p>
                  <p className="text-xs text-background-100/80">{site.tagline}，不做标题党。</p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
              {praise.map((t) => (
                <figure key={t.who} className="rounded-xl bg-background-100 p-4 ring-1 ring-background-200/70">
                  <div className="flex text-accent-500">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-xs" aria-hidden="true"></i>
                    ))}
                  </div>
                  <blockquote className="mt-2 text-xs leading-relaxed text-foreground-700">「{t.text}」</blockquote>
                  <figcaption className="mt-2 text-xs text-foreground-400">— {t.who}</figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}